import OperationDetailModal from '../../../components/OperationDetailModal.vue';
import Vue from 'vue';
const operationDetailModalHandler = (
  detailData,
  operation,
  operationList,
  spotList,
  distanceMatrixManual,
  callback,
) => {
  const vm = new Vue({
    ...OperationDetailModal,
    propsData: {
      detailData,
      operation,
      operationList,
      spotList,
      distanceMatrixManual,
      callback,
    },
  });
  vm.$mount();
  vm.$bvModal.show('operation-detail-modal');
};
export default operationDetailModalHandler;
